import { render, staticRenderFns } from "./TeamsEdit.vue?vue&type=template&id=4e508a49&"
import script from "./TeamsEdit.vue?vue&type=script&lang=js&"
export * from "./TeamsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports